(function($, global) {
  //get customer bonus balance
  global.forTreeJSConf = globalConf(globalForTreeJSConf);

  const bonusBalance = () => global.forTreeJSConf.customer.bonusBalance;
  $(document).ready(bonusBalance());

  $(document).on('change', 'payment-type-switcher input', function () {
    //get variables
    const input = $(this),
          inputRelatedVariant = input.attr('data-related-variant'),
          inputProductTitle = input.attr('data-product-title'),
          inputProductPrice = input.attr('data-product-price'),
          inputProductBonusPrice = input.attr('data-bonus-price');

    const inputVariantJson = JSON.parse(inputRelatedVariant);
    let   isProductBonusesOnly = (input.val() === 'xp');
    const productForm = input.closest('.product-info'),
          productFormBlock = productForm.find('product-form'),
          productOldPrice = productForm.find('.product-price--old'),
          customerId = productForm.attr('data-customer-id'),
          productTitle = productForm.find('h1.title span:first-child'),
          productQuantity = productFormBlock.find('.quantity-input'),
          productFormBtnText = productFormBlock.find('.js-add-to-cart .btn__text');
    const productPriceField = () => (productForm.find('.price-xp').length > 0) ? 
          productForm.find('.product-price-xp') : 
          productForm.find('.product-price');
    const variantPriceWithCurrency = () => isProductBonusesOnly ? 
          (`${inputProductBonusPrice} XP`) : 
          (`${inputProductPrice / 100} грн`);
    const notAuthBlock = productForm.find('.product--not-auth'),
          variantFormInput = productForm.find('input[name="id"]'),
          linkHref = input.attr('data-url');


    window.history.replaceState({ }, '', `${linkHref}?variant=${inputVariantJson.id}`);

    // render image
    if ( inputVariantJson.title !== 'Default Title' ) {
      $('#product-gallery').load(location.href + ' #product-gallery');
    }
  
    // render title
    productTitle.text(inputProductTitle);

    // render variants selector
    $('#relatedProductVariants').load(location.href + ' #relatedProductVariants');
    $('#productVariants').load(location.href + ' #productVariants');

    // render price
    productPriceField().text(variantPriceWithCurrency());

    if ( isProductBonusesOnly ) {
      productPriceField().css({'color': '#f50', 'marginRight': '15px'}).siblings().show();

      if ((productPriceField().siblings().length === 1) && (inputVariantJson.price > 0)) {
        $(`<span class="product-price-xp-price">+ ${(inputVariantJson.price / 100).toFixed(2)} грн</span>`).insertAfter(productPriceField());
      }

    } else {
      productPriceField().css({"color": "#2b2d2f"}).siblings().hide().parent().removeClass('flex-center');
    }

    if ( productOldPrice ) productOldPrice.hide();
    
    // render login link when no auth
    if ( customerId === undefined ) {

      if ( isProductBonusesOnly ) {
        productFormBlock.addClass('hidden');
        notAuthBlock.removeClass('hidden');
      } else {
        productFormBlock.removeClass('hidden');
        notAuthBlock.addClass('hidden');
      }
    }

    // disabled/enabled atc button
    productFormBlock.find('.has-tt').addClass('disactive');

    if ( inputVariantJson.available === true ) {

      productQuantity.removeClass('hidden');
      productFormBlock.find('.js-add-to-cart').removeClass('disabled');
      productFormBtnText.text('Додати в кошик');

      if ( isProductBonusesOnly && bonusBalance() < inputProductBonusPrice ) {
        productFormBlock.find('.js-add-to-cart').addClass('disabled');
        productFormBlock.find('.has-tt').removeClass('disactive');
      }

    } else {
      productQuantity.addClass('hidden');
      productFormBlock.find('.js-add-to-cart').addClass('disabled');
      productFormBtnText.text('Очікується');
    }

    // push atc value
    variantFormInput.val(inputVariantJson.id);
    console.log(inputVariantJson);
  });
  
})(jQuery, this);